// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAuK4ls_ZNC6m87TrUYpVEI6ES7bavXZrc',
    authDomain: 'npfp-226819.firebaseapp.com',
    databaseURL: 'https://npfp-226819.firebaseio.com',
    projectId: 'npfp-226819',
    storageBucket: 'npfp-226819.appspot.com',
    messagingSenderId: '269223792663',
  }
};
